/**
 * Created by wuhuping on 2017/5/16.
 */
import dateFormatter from './dateFormatter'
export default {
  // parse channel
  parseChannel() {
    let channelMark = 'chanNo='
    let appMark = 'isApp=true'
    let iosMark = 'isIosCheck=true'
    if (window.location.href.indexOf(iosMark) !== -1) window.sessionStorage.setItem('isIosCheck', true)
    if (window.location.href.indexOf(channelMark) > 0) {
      window.sessionStorage.setItem('isURLValidate', true)
      // channel
      let channelStartIndex = window.location.href.indexOf(channelMark)
      let chanNo = window.location.href.substr(channelStartIndex + channelMark.length)
      let contactCharIndex = chanNo.indexOf('&')
      if (contactCharIndex !== -1) {
        chanNo = chanNo.substr(0, contactCharIndex)
      }
      window.sessionStorage.setItem('chanNo', chanNo)
    }
    if (window.location.href.indexOf(appMark) > 0) {
      window.sessionStorage.setItem('isApp', true)
    }
  },
  isIosCheck() {
    return !!window.sessionStorage.getItem('isIosCheck')
  },
  // is url validate
  isUrlValidate() {
    return window.sessionStorage.getItem('isURLValidate') === 'true'
  },
  chanNo() {
    let chanNo = window.sessionStorage.getItem('chanNo')
    if (chanNo) {
      return chanNo
    } else {
      return ''
    }
  },
  updateChanNo(chanNo) {
    window.sessionStorage.setItem('chanNo', chanNo)
  },
  isApp() {
    return !!window.sessionStorage.getItem('isApp')
  },
  fetchWxLoginCode() {
    let codeMark = 'code=';
    let codeStartIndex = window.location.href.indexOf(codeMark);
    if (codeStartIndex !== -1) {
      let code = window.location.href.substr(codeStartIndex + codeMark.length);
      let contactCharIndex = code.indexOf('&');
      if (contactCharIndex !== -1) {
        code = code.substr(0, contactCharIndex);
      }
      return code;
    } else {
      return undefined;
    }
  },
  saveWxSessionID(sessionID) {
    window.sessionStorage.setItem('wxSessionID', sessionID);
  },
  fetchWxSessionID() {
    return window.sessionStorage.getItem('wxSessionID');
  },
  getNetworkType() {
    var ua = navigator.userAgent
    var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other'
    networkStr = networkStr.toLowerCase().replace('nettype/', '')
    var networkType
    switch (networkStr) {
      case 'wifi':
        networkType = 'wifi'
        break
      case '4g':
        networkType = '4g'
        break
      case '3g':
        networkType = '3g'
        break
      case '3gnet':
        networkType = '3g'
        break
      case '2g':
        networkType = '2g'
        break
      default:
        networkType = 'other'
    }
    return networkType
  },
  detectOS() {
    let systemInfo = {}
    let sUserAgent = navigator.userAgent
    let isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows')
    let isMac = (navigator.platform === 'Mac68K') || (navigator.platform === 'MacPPC') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel')
    if (isMac) systemInfo.system = 'Mac'
    let isUnix = (navigator.platform === 'X11') && !isWin && !isMac
    if (isUnix) systemInfo.system = 'Unix'
    let isLinux = (String(navigator.platform).indexOf('Linux') > -1)
    let bIsAndroid = sUserAgent.toLowerCase().match(/android/i) === 'android'
    let isAndroid = sUserAgent.indexOf('Android') !== -1
    let isIos = !!sUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    if (isIos) {
      let tempVer = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
      systemInfo.osType = '02'
      systemInfo.system = 'IOS'
      systemInfo.version = parseInt(tempVer[1], 10)
    } else if (isAndroid) {
      systemInfo.osType = '01'
      systemInfo.system = 'Android'
    } else if (isLinux) {
      if (bIsAndroid) {
        systemInfo.osType = '01'
        systemInfo.system = 'Android'
        systemInfo.version = sUserAgent.substr(sUserAgent.indexOf('Android') + 8, 5)
      } else {
        systemInfo.osType = '01'
        systemInfo.system = 'Android'
        // systemInfo.osType = '04'
        // systemInfo.system = 'Linux'
      }
    } else if (isWin) {
      systemInfo.osType = '03'
      let system
      let is64 = sUserAgent.indexOf('WOW64') > -1
      let isWin2K = sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1
      if (isWin2K) system = 'Win2000'
      let isWinXP = sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1
      sUserAgent.indexOf('Windows XP') > -1
      if (isWinXP) system = 'WinXP'
      let isWin2003 = sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1
      if (isWin2003) system = 'Win2003'
      let isWinVista = sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1
      if (isWinVista) system = 'WinVista'
      let isWin7 = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1
      if (isWin7) system = 'Win7'
      let isWin8 = sUserAgent.indexOf('windows nt6.2') > -1 || sUserAgent.indexOf('Windows 8') > -1
      if (isWin8) system = 'Win8'
      systemInfo.system = system
      if (is64) {
        systemInfo.version = '64位'
      } else {
        systemInfo.version = '32位'
      }
    } else {
      systemInfo.system = '其他'
    }
    return systemInfo
  },
  // 生成设备随机启动编号，编号规则为：年-月-日-时-分-秒-毫秒+6位随机数字
  setDeviceStartNo() {
    let randomNo = ''
    for (let i = 0; i < 6; i++) {
      randomNo += Math.floor(Math.random() * 10)
    }
    return dateFormatter.setTime() + randomNo
  }
}



// WEBPACK FOOTER //
// ./src/tools/channel.js